import React from 'react';
import PageContentContainer from 'src/components/PageContentContainer';
import StickyPageHeader from 'src/components/StickyPageHeader';
import './styles.scss';
/* eslint-disable */
const Version: React.VoidFunctionComponent = ({
}) => {

  return (
    <PageContentContainer>
      <StickyPageHeader>
        <br/>
        <h3>Branch: train/1.8.0-RC2</h3><br />
        <h3>Commit: bc9dc4a3</h3><br />
        <h3>Build Date: 2024-11-29T17:25:47Z</h3>
      </StickyPageHeader>
    </PageContentContainer>
  );
};

export default (Version);